// extracted by mini-css-extract-plugin
export var settingsList = "_37-0";
export var settingsRow = "_37-1";
export var warningDot = "_37-2";